<template>
  <AddressCard
    :num-uri-string="numUriString"
    :result="result"
    v-if="result && result.method_type === 'address'"
  />
  <GpsCard
    :num-uri-string="numUriString"
    :result="result"
    v-else-if="result && result.method_type === 'gps'"
  />
  <LinkCard
    :num-uri-string="numUriString"
    :result="result"
    v-else-if="result && result.method_type === 'link'"
  />
  <ThirdPartyCard
    :num-uri-string="numUriString"
    :result="result"
    v-else-if="result && result.controller"
  />
  <ResultCard :num-uri-string="numUriString" :result="result" v-else />
</template>

<script>
import AddressCard from "@/views/Home/Card/Address";
import GpsCard from "@/views/Home/Card/Gps";
import ThirdPartyCard from "@/views/Home/Card/ThirdParty";
import LinkCard from "@/views/Home/Card/Link";
import ResultCard from "@/views/Home/Card/Result";

export default {
  name: "ResultItem",
  components: {
    AddressCard,
    GpsCard,
    ThirdPartyCard,
    LinkCard,
    ResultCard,
  },
  props: {
    numUriString: String,
    result: Object,
  },
};
</script>
